/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateBannerVisibilityResponse } from '../../models/update-banner-visibility-response';

export interface AdminServiceUpdateBannerVisibility$Params {
  bannerId: string;
  visible: boolean;
}

export function adminServiceUpdateBannerVisibility(http: HttpClient, rootUrl: string, params: AdminServiceUpdateBannerVisibility$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateBannerVisibilityResponse>> {
  const rb = new RequestBuilder(rootUrl, adminServiceUpdateBannerVisibility.PATH, 'put');
  if (params) {
    rb.path('bannerId', params.bannerId, {});
    rb.path('visible', params.visible, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateBannerVisibilityResponse>;
    })
  );
}

adminServiceUpdateBannerVisibility.PATH = '/api/v3/gateway/admin/banner/{bannerId}/visibility/{visible}';
